import { useTranslation } from "react-i18next";
import { holdingIsRated } from "../../../api/services/etf.normalize";
import badgeStyles from "../../components/HalalStatusBadge/HalalStatusBadge.module.css";
import screenerStyles from "../StockScreener/stockScreener.module.css";
import { EtfVerdictBadge } from "../EtfScreener/EtfVerdictBadge";

/**
 * A constituent's verdict. null, ERROR_DATA, UNQUALIFIED and a rulebook's
 * INCOMPLETE_DATA all render "Not rated" in the neutral badge: we declined to
 * rate it, which is never the same as compliant (handover §B4).
 */
export const HoldingStatusBadge = ({ status }: { status: string | null }) => {
  const { t } = useTranslation();
  if (holdingIsRated(status)) return <EtfVerdictBadge status={status} compact />;
  const label = t("pages.etfDetail.holdings.notRated");
  return (
    <span
      className={`${badgeStyles.badge} ${badgeStyles.unknown} ${screenerStyles.statusCompact}`}
      title={label}
    >
      {label}
    </span>
  );
};
